import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Smooth-scrolls to the URL hash target on route change and on hash change.
 * Runs inside BriefRoutes so it only applies to the reading experience.
 *
 * Design intent: sidebar anchor links and in-page TOCs should feel calm and
 * intentional, not a jarring jump.
 */
export const ScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      // On a fresh navigation without a hash, honor the top of the page.
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
      return;
    }
    const id = decodeURIComponent(location.hash.slice(1));
    // Defer to allow the destination page to mount its anchors.
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 40);
    return () => clearTimeout(t);
  }, [location.pathname, location.hash]);

  return null;
};

export default ScrollToHash;
